import React from 'react';
import { MailIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section id="final-cta" className="w-full bg-navy-deep py-16 sm:py-24" aria-labelledby="final-cta-title" data-id="element-41" data-mp="vh0scm59e1tj">
      <div className="mx-auto max-w-3xl px-6" data-id="element-42" data-mp="15dlvf1xpx2uq">
        <h2 id="final-cta-title" className="text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-50 sm:text-4xl" data-id="element-43" data-mp="15bsn7i7giakm">
          Last Chance To Protect What Matters Most.
        </h2>

        <div className="mt-8 space-y-5 text-lg leading-relaxed text-slate-300" data-id="element-44" data-mp="1ec7k7ets9e3y">
          <p data-id="element-45" data-mp="1t251datap3jn">
            Tonight, while you sleep, there are medications in your home that may be expired,
            degraded, incorrectly stored, or dangerously combined with something you took this
            morning.
          </p>
          <p data-id="element-46" data-mp="1x4tehup1kwmf">
            You don’t know which ones. You have no system to check. And tomorrow will be exactly the
            same as today — unless something changes right now.
          </p>
          <p className="font-semibold text-slate-50" data-id="element-47" data-mp="s4fkxxy9413m">The Pharma-Masterclave is that change.</p>
          <p data-id="element-48" data-mp="x3s7ehl7n65o">
            Six professional guides. Three immediate action tools. The pharmaceutical safety standard
            your family has always deserved.
          </p>
          <p className="font-semibold text-trust" data-id="element-49" data-mp="120scap6bq2v7">For $27 — one time — yours forever.</p>
        </div>

        <div className="mt-12 rounded-3xl border border-white/10 bg-white/[0.04] p-8 text-center sm:p-10" data-id="element-50" data-mp="162dwywp3nlfy">
          <p className="text-xl font-extrabold uppercase tracking-wide text-slate-50" data-id="element-51" data-mp="1b172a1u8g651">
            The Pharma-Masterclave
          </p>
          <p className="mt-2 text-sm font-medium uppercase tracking-[0.14em] text-slate-400" data-id="element-52" data-mp="1ktmhire5agm8">
            Visual Integrity &amp; Safety System
          </p>
          <p className="mt-3 text-sm font-semibold text-trust" data-id="element-53" data-mp="1pqmor5mqdpex">
            6 Complete Guides + 3 Action Tools Included
          </p>

          <p className="mt-8 flex items-baseline justify-center gap-3" data-id="element-54" data-mp="3qu5ps7r3bnp3">
            <s className="text-2xl font-bold text-slate-500 decoration-red-400 decoration-2" data-id="element-55" data-mp="3lvknm2sa2ty0">
              $197
            </s>
            <span className="text-5xl font-extrabold tracking-tight text-slate-50 sm:text-6xl" data-id="element-56" data-mp="3huxj0knqvky">
              $27
            </span>
          </p>

          <div className="mt-8" data-id="element-57" data-mp="3uuz9sq1ewicp">
            <CtaButton href="#offer" className="w-full" data-id="element-58" data-mp="dfisnrm6e53n">
              ✅ Yes — I’m protecting my family today ($27)
            </CtaButton>
          </div>

          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-slate-300" data-id="element-59" data-mp="8gfyx3bnblaz">
            <MailIcon className="h-4 w-4 text-trust" aria-hidden="true" data-id="element-60" data-mp="mfxhh0ycm2bw" />
            Instant access: delivered to your email immediately after purchase.
          </p>
          <p className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-slate-300" data-id="element-61" data-mp="2o7275rgq0stl">
            <span className="flex items-center gap-2" data-id="element-62" data-mp="2k7a39s29vauk">
              <span className="flex items-center gap-0.5 text-trust" aria-hidden="true" data-id="element-63" data-mp="2a2a7fnipdffd">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-64" data-mp="2e2u5ctb3on2k" />)}
              </span>
              <span className="font-semibold text-slate-50" data-id="element-65" data-mp="20bz4o4ar9ca2">4.9/5 Verified Reviews</span>
            </span>
            <span className="flex items-center gap-2 text-slate-400" data-id="element-66" data-mp="25a0jue528rg9">
              <ShieldCheckIcon className="h-4 w-4 text-trust" aria-hidden="true" data-id="element-67" data-mp="1qd9ku5zathr6" />
              7-Day Money-Back Guarantee · No Risk
            </span>
          </p>
        </div>
      </div>
    </section>;
}